<template>
  <lottie
    v-if="isAnimation"
    :options="options"
    :height="height"
    :width="width"
    :id="id"
    :name="id || name"
    :text="id || text"
  />
  <img
    v-else
    :src="options"
    :id="id"
    :name="id || name"
    :height="height"
    :width="width"
  />
</template>

<script>
import Lottie from 'vue-lottie';

/**
 * https://github.com/chenqingspring/vue-lottie for available properties and methods
 * Note: No issues have been addressed recently, `.default` is required for animation
 *        to render - the documentation lies
 */
export default {
  name: 'BaseImage',
  components: {
    lottie: Lottie
  },
  computed: {
    isAnimation() {
      return !!(this.src && this.src.default);
    },
    options() {
      if (this.isAnimation) {
        return {
          animationData: this.src.default,
          loop: this.loop,
          autoplay: this.autoplay,
        }
      }
      return this.src;
    },
  },
  props: {
    src: {
      required: true,
    },
    height: {
      type: String,
    },
    width: {
      type: String,
    },
    loop: {
      type: Boolean,
      default: true,
    },
    autoplay: {
      type: Boolean,
      default: true,
    },
    id: {
      type: String,
    },
    text: {
      type: String,
    },
    name: {
      type: String,
    },
  },
}
</script>